import api from "@/assets/scripts/api";
import { genMaterialData } from "@/assets/scripts/common";
import { getLabelStyleMenu } from "@/assets/scripts/common.js";
import http from "@/plugins/http";
// 获取文字样式
export const getCoverTextStyles = async sizeId => {
  let result = await http.get(api.textStyle, {
    sizeId,
    platformType: 2,
  });
  return result.data.list;
};
// 获取封面的业务线（sizes）
export const getProdSizes = async () => {
  let { data } = await http.get(api.sizesbytype, { platformType: 2 });
  return data.list || [];
};
// 设置主标题换行
export const setMainTitle = (fontStyle, oldText) => {
  let text = fontStyle.text;
  if (!text) return;
  const half = parseInt(fontStyle.textMaxLength / 2);
  // 插入换行符的位置
  let pos = 0;
  // 文字最大长度大于最小长度的两倍时，插入换行符
  if (fontStyle.textMaxLength >= fontStyle.textMinLength * 2) {
    const reg = /\n/g;
    const matchLen = text.match(reg) ? text.match(reg).length : 0;
    let ret;
    if (matchLen === 1) {
      pos = reg.exec(text).index;
    } else if (matchLen > 1) {
      while ((ret = reg.exec(text)) != null) {
        // 当前的换行符是不是在oldText也有
        if (oldText.substr(ret.index, 1) !== ret[0]) {
          pos = ret.index;
          break;
        }
        reg.lastIndex = ret.index + 1;
      }
    } else {
      pos = half;
    }
    text = text.replace(/\n/g, "").substr(0, fontStyle.textMaxLength);
    // pos && (text = text.slice(0, pos) + "\n" + text.slice(pos));
    // 以下是新的不合理需求
    if (pos > half || text.length - pos > half) {
      pos = half;
    }
    pos && (text = text.slice(0, pos) + "\n" + text.slice(pos));
  } else {
    // 不需要换行的banner
    text = text.replace(/\n/g, "").substr(0, fontStyle.textMaxLength);
  }
  return text;
};
// 检查文字
export const checkCoverText = fontStyles => {
  let isLegal = true;
  for (let textMap of fontStyles) {
    if (!textMap.isShowText) continue;
    if (!textMap.text) {
      isLegal = false;
      break;
    }
    const min = textMap.textMinLength;
    let max = textMap.textMaxLength;
    const textLen = textMap.text.length;
    if (textMap.isMainTitle && /\n/g.test(textMap.text)) {
      max += 1;
    }
    if (textLen < min || textLen > max) {
      isLegal = false;
      break;
    }
  }
  return isLegal;
};
// 设置封面数据
export const setCoverData = (target, element, background) => {
  const data = genMaterialData(element, background);
  target.updateCoverData(data);
  target.updateCoverDataList(data);
};
// 设置封面文字的属性
export const setTextStyleMap = (styleMap, index, labelStyle = "样式1") => {
  const limits = styleMap.textCountLimit.split("<x<");
  styleMap.textMinLength = parseInt(limits[0]);
  styleMap.textMaxLength = parseInt(limits[1]);
  styleMap.lineIndex = index;
  // 是否是主标题(主标题为文字加粗且不需要标签样式)
  styleMap.isMainTitle = /Heavy|Black/.test(styleMap.fontFamily) && !styleMap.isLabelStyle;
  styleMap.labelName = styleMap.isMainTitle ? "标题" : "标签" + (index + 1);
  // 是否显示该行文字，用户的设计详情中返回文字为空时，该行文字置灰
  styleMap.isShowText = !(!styleMap.text && styleMap.text !== undefined);
  styleMap.labelStyle = styleMap.labelStyle || labelStyle;
  return styleMap;
};
// 提交用户设计
export const saveCoverToBase = async (coverDatas, schemeId = "", userId = "") => {
  let coverDataList = JSON.parse(JSON.stringify(coverDatas));
  coverDataList.find((item, index) => {
    if (item.type === 0) {
      coverDataList.splice(index, 1);
      coverDataList.unshift(item);
      return true;
    }
  });
  let { tagId, elementId, textStyleId, backgroundId, isAiElement } = coverDataList[0];
  let scheme = {
    id: schemeId,
    tagId,
    elementId,
    isAiElement,
    backgroundId,
    textStyleId,
    platformType: 2,
    sizeTexts: coverDataList.map(coverData => ({
      sizeId: coverData.sizeId,
      logoContent: "",
      texts: coverData.fontStyles.map(item => {
        return (item.isShowText && item.text) || "";
      }),
      labelStyle: coverData.fontStyles.map(item => {
        return item.isShowText && item.isLabelStyle ? item.labelStyle : "";
      }),
    })),
  };
  if (userId) {
    return http.post(api.saveSchemeByUser, {
      ...scheme,
      userId,
    }).catch((err) => {
      console.log("报错cover失败", err);
    });
  }
  return http.post(api.scheme, scheme).catch((err) => {
    console.log("报错cover失败", err);
  });
};
// 根据尺寸size信息构造coverData
export const genCoverDataBySize = (size, element, background) => {
  const {
    id,
    elementHeight,
    elementWidth,
    height,
    width,
    offsetX,
    offsetY,
    remainPart,
    sizeName,
    textAlignType,
    textPositionX,
    textPositionY,
    textStyle,
    textStyleId,
    type,
  } = size;
  const fontStyles = JSON.parse(JSON.stringify(textStyle)).map((style, i) => {
    const styleMap = setTextStyleMap(style, i);
    const text = style.text || "";
    styleMap.text = styleMap.isMainTitle ? setMainTitle({ ...styleMap, text }, text) : text;
    return styleMap;
  });
  // 设置选中的size
  const cover = {
    textStyleId,
    sizeId: id + "",
    sizeName,
    type,
    size: {
      width,
      height,
    },
    elementInfo: {
      elementWidth,
      elementHeight,
      offsetX,
      offsetY,
      remainPart,
    },
    textInfo: {
      textPositionX,
      textPositionY,
      textAlignType,
    },
    fontStyles,
  };
  if (element && background) {
    const eTagIds = Array.isArray(element.tagIds)
      ? element.tagIds
      : element.tagIds.split(",");
    const bTagIds = Array.isArray(background.tagIds)
      ? background.tagIds
      : background.tagIds.split(",");
    // 取eTagIds和bTagIds的交集
    const tagIds = eTagIds.filter(item => bTagIds.includes(item));
    cover.tagId = tagIds[0] || bTagIds[0];
    return {
      ...genMaterialData(element, background),
      ...cover,
    };
  }
  return cover;
};

export const getCoverDataBySchemeId = async (schemeId) => {
  let { data } = await http.get(
    `${api.scheme}?schemeId=${schemeId}&platformType=2`
  );
  if (data.list.length) {
    data.list.forEach((element) => {
      // 获取label样式表
      const labelStyleMenu = getLabelStyleMenu(
        element.bgParameter.tagBgColor
      );
      const { fontStyles } = element;
      fontStyles.forEach((item, index) => {
        // 将label样式追加到字体样式中
        const lableStyleMap =
          labelStyleMenu[item.labelStyle.slice(-1)] || {};
        lableStyleMap.style && Object.assign(item, lableStyleMap.style);
        setTextStyleMap(item, index);
      });
    });
    return data.list;
  }
  return [];
}
